module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-5 ovf-hd"
  }, [_c('div', {
    staticClass: "fl w-400"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入发票内容",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1), _c('span', {
    staticClass: "m-l-30",
    staticStyle: {
      "color": "#111"
    }
  }, [_vm._v("企业："), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700",
      "margin-top": "7px",
      "color": "#111"
    }
  }, [_vm._v(_vm._s(_vm.company_name))])])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "导入人",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "发票号码",
      "fixed": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "发票代码",
      "show-overflow-tooltip": true,
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buyer_tax_number",
      "label": "购买方税号",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("正常")]) : (scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : (scope.row.status == -1) ? _c('span', {
          staticStyle: {
            "color": "#d00"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "验真状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.is_really == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("验真成功")]) : (scope.row.is_really == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v("未验真")]) : (scope.row.is_really == -1) ? _c('span', [_vm._v("验真失败")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报销状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.bill_status >= 1 && scope.row.bill_status <= 5) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v("报销中")]) : (scope.row.bill_status == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v("待提交")]) : (scope.row.bill_status == 6) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("已报销")]) : (scope.row.bill_status == -1) ? _c('span', [_vm._v("未报销")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "day",
      "label": "开票日期",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "no_tax_money",
      "label": "不含税金额",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tax_money",
      "label": "税额",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money",
      "label": "价税合计金额",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "销售方",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project",
      "label": "项目名称",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buyer",
      "label": "购买方",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "导入时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件预览",
      "fixed": "right",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.img_type == 2) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.ofd_detail = [];
              _vm.ofd_detail = scope.row;
              _vm.look_ofd_file = true
            }
          }
        }, [_vm._v("预览文件")]) : _vm._e(), _vm._v(" "), (scope.row.img_type != 2) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.img_detail = [];
              _vm.img_detail = scope.row;
              _vm.look_img_file = true
            }
          }
        }, [_vm._v("预览文件")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.look_ofd_file,
      "append-to-body": "",
      "close-on-click-modal": true,
      "show-close": false,
      "custom-class": "w-650"
    },
    on: {
      "update:visible": function($event) {
        _vm.look_ofd_file = $event
      }
    }
  }, [_c('ofdGroup', {
    attrs: {
      "ofd_detail": _vm.ofd_detail
    },
    on: {
      "closeMain": function($event) {
        _vm.look_ofd_file = false;
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.look_img_file,
      "append-to-body": "",
      "close-on-click-modal": true,
      "show-close": false,
      "custom-class": "w-650"
    },
    on: {
      "update:visible": function($event) {
        _vm.look_img_file = $event
      }
    }
  }, [_c('imgGroup', {
    attrs: {
      "img_detail": _vm.img_detail
    },
    on: {
      "closeMain": function($event) {
        _vm.look_img_file = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-022aa66f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/company/company_bill_folder.vue
// module id = 1791
// module chunks = 2